module.exports = __webpack_public_path__ + "static/img/2.0cdd9b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/2.png
// module id = Lygk
// module chunks = 0